<template>
	<div class="iboard" :class="classes">
    <component v-bind:is="currentControlPanel" :recent-action="recentAction" :show-notice="showNotice" />
	</div>
</template>

<script>
import { mapState } from 'vuex'

import EssenzaControlPanel from './controlPanels/Essenza.vue'

const controlPanelMap = {
	'essenza300'  : EssenzaControlPanel,
	'essenza300lt': EssenzaControlPanel
}

export default {
	data() {
		return {
			recentAction: '',
      showNotice: false,
      combinedTiltingCounter: 1
		}
	},
	computed: {
    ...mapState({
			disableBoard: state => state.navigation.disableBoard,
      transferModeOn: state => state.navigation.transferModeOn
		}),
    currentControlPanel() {
      return controlPanelMap[this.$store.state.activeProduct]
    },
    classes() {
      return {
        'disabled': this.disableBoard,
        [`iboard--${this.$store.state.activeProduct}`]: true
      }
    },
	},
	mounted() {
		const doubleBtns = document.querySelectorAll('.double-btn .clickable')
		doubleBtns.forEach(el => {
			const isFirst = el.nextSibling?.classList.contains('clickable')
			el.addEventListener('mousedown', () => {
				el.parentElement.classList.add(isFirst ? 'active-first' : 'active-second')
			})
			el.addEventListener('mouseup', () => {
				el.parentElement.classList.remove('active-first', 'active-second')
			})
			el.addEventListener('mouseleave', () => {
				el.parentElement.classList.remove('active-first', 'active-second')
			})
		})

		const allBtns = document.querySelectorAll('.clickable')

		allBtns.forEach(el => {
			el.addEventListener('click', (e) => {
				e.stopPropagation()
				this.onButtonClick(el)
			})
      el.addEventListener('mouseover', (e) => {
				e.stopPropagation()
        const animation = this.$store.state.productConfig.animations[el.dataset.action]
        this.recentAction = animation.en
			})
      el.addEventListener('mouseleave', (e) => {
				e.stopPropagation()
        this.recentAction = ''
			})
		})
	},
  watch: {
    transferModeOn: function(newVal) {
      if (newVal) {
        this.showNotice = true

        setTimeout(() => {
          this.showNotice = false
        }, 3000)
      }
    }
  },
	methods: {
		onButtonClick(el) {
			const action = el.dataset.action
			if (action) {
				if (['transfer_mode_on', 'transfer_mode_off'].includes(action)) {
          this.$store.commit('navigation/setTransferModeOn', action === 'transfer_mode_on')

          if (this.disableBoard) {
            if (action === 'transfer_mode_on') {
              this.$store.commit('navigation/setDisableBoard', false)
            }
          }

					this.setRecentAction(action)
					return
				}

        if (action === 'autocontour_adjustment') {

          const animation = this.$store.state.productConfig.animations[action]

          this.$bus.emit('requestModelAnimation', {
            name: 'backrest_adjustment',
            direction: el.dataset.direction,
            binary: 'binary' in el.dataset
          })
          this.$bus.emit('requestModelAnimation', {
            name: 'thighrest_adjustment',
            direction: el.dataset.direction,
            binary: 'binary' in el.dataset
          })

          this.setRecentAction(animation.en || action)
					
					return
				}

        if (action === 'combined_tilting') {

          const actionName = `combined_tilting${this.combinedTiltingCounter}`

          const animation = this.$store.state.productConfig.animations[actionName]

          this.$bus.emit('requestModelAnimation', {
            name: actionName,
            direction: el.dataset.direction,
            binary: 'binary' in el.dataset
          })

          this.setRecentAction(animation.en || action)

          if (this.combinedTiltingCounter === 4) {
            this.combinedTiltingCounter = 1
          } else {
            this.combinedTiltingCounter++
          }
					
					return
				}

				const animation = this.$store.state.productConfig.animations[action]

				this.$bus.emit('requestModelAnimation', {
					name: action,
					direction: el.dataset.direction,
					binary: 'binary' in el.dataset
				})
				this.setRecentAction(animation.en || action)
			}
		},
		setRecentAction(name) {
			this.recentAction = name.replaceAll('_', ' ')
		}
	}
}
</script>

<style lang="scss">
.iboard {
	line-height: 0;
	border-radius: 13px;
	box-shadow: 0 2px 10px #00000040;

  &__turn-on {
    position: absolute;
    bottom: 22px;
    right: 23px;
    width: 69px;

    @media screen and (max-width: 1800px), screen and (max-height: 500px) {
			bottom: 21px;
      right: 20px;
      width: 60px;
		}
  }

  &--sprint {
    box-shadow: none;
  }

  &.disabled {
    :not(.not-disabled) {
      .double-btn {
        opacity: 0.25;
        pointer-events: none;
        transition: 0.25s;
      }
      :not(.double-btn) {
        .clickable:not(.clickable--tmo) {
          opacity: 0.25;
          pointer-events: none;
          transition: 0.25s;
        }
      }
      .graphics {
        opacity: 0.25;
        pointer-events: none;
        transition: 0.25s;
      }
    }
    .blink {
      > path {
        animation-name: backgroundColorChange;
        animation-duration: 1s;
        animation-iteration-count: infinite;
        animation-direction: alternate;
      }
    }

    @keyframes backgroundColorChange{
      0% {
        fill: #E2ECFA;
      }
      100% {
        fill: $clrOrange;
      }
    }
  }

	svg {
		width: 380px;
		height: auto;
		@media screen and (max-width: 1800px), screen and (max-height: 500px) {
			width: 340px;
		}
	}

	.clickable {
		pointer-events: auto;
		cursor: pointer;
		padding: 10px;

		&:hover {
			path[fill="#d7e3f3"] {
				fill: #e2ecfa;
			}
			> circle {
				fill: rgba(255,255,255,0.3);
			}
		}

		&:active {
			filter: none;
			> circle {
				fill: transparent;
			}
			path[fill="#d7e3f3"] {
				fill: #baceea;
			}
			path[fill="url(#btn-gradient)"] {
				fill: url(#btn-gradient-inverse);
			}

			path[fill="url(#btn-gradient-3d)"],
			path[fill="url(#btn-gradient-3d-alt)"] {
				fill: #54565a;
			}

			path[fill="url(#btn-gradient-3d-red)"] {
				fill: #e1251b;
			}

			path[fill="url(#btn-gradient-white)"] {
				fill: #fbfbfb;
			}
		}

		&.highlighted {
			> path {
				fill: $clrOrange !important;
			}
		}
	}

	.no-action {
		cursor: not-allowed;
	}

  .notice {
    position: absolute;
    color: #fff;
    display: flex;
    flex-direction: column;
    top: 45px;
    left: 50%;
    transform: translate(-50%, 16px);
    border-radius: 12px;
    width: 195px;
    // box-shadow: 0px 10px 13px -7px #000000, 5px 5px 15px 5px rgba(0,0,0,0);
    line-height: 1.15;
    font-size: 11px;
    opacity: 0;
    transition: 0.25s ease-out;

    @media screen and (max-width: 1800px) {
      width: 170px;
    }

    &.is-active {
      opacity: 1;
      transform: translate(-50%, 0);
    }

    &__header {
      height: 20px;
      background-color: $clrOrange;
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;

      div {
        border-radius: 100%;
        display: inline-flex;
        justify-content: center;
        margin-left: 8px;
        font-size: 10px;
        margin-top: 4px;
        align-items: center;
        background-color: #fff;
        width: 10px;
        height: 10px;
        color: $clrOrange;
      }
    }

    &__text {
      padding: 8px;
      background-color: darken($color: #E2ECFA, $amount: 10%);
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  }
}
</style>
